import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  FULL_BUSINESS_URL,
  KeywordsPages,
} from '../../utils/constants/Constants';
import { SESSIONS_PAGE_URL, HOME_PAGE_URL } from '../../utils/constants/Routes';

// Data
import {
  sessionsPageAdditionalMeta,
  sessionsPageStructuredData,
} from '../../utils/data/MetaData';

// Images
import MainImage from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-tattoo-thigh.webp';

// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import SessionsPageMainContainer from '../../components/sessions/SessionsPageMainContainer';

// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import FAQSchema from '../../utils/seo/FAQSchema';
import { sessionsPageFaqItems } from '../../utils/data/faqSchemas';

function SessionsPage() {
  const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [
      { label: 'Home', href: HOME_PAGE_URL },
      { label: 'Sessions', href: SESSIONS_PAGE_URL },
    ],
  });

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Sessions'
        desc={`Experience the ultimate submission with ${CompanyName}. Explore My session offerings, tributes, and the privileges that await those who dare to serve.`}
        keywords={KeywordsPages}
        additionalMeta={sessionsPageAdditionalMeta}
        structuredData={[sessionsPageStructuredData, breadcrumbLd]}
        canonicalPath={SESSIONS_PAGE_URL}
      />

      {/* Page */}
      <div className='grid relative min-h-screen font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='pt-24 px-8 lg:container lg:mx-auto lg:px-24'>
            <h1
              aria-label={`Sessions with ${CompanyName}`}
              className='text-center font-titleFont text-6xl lg:text-6xl tracking-widest'
            >
              Sessions
            </h1>

            <div className='mx-auto grid justify-center'>
              <h2 className='text-xl xs:text-2xl mt-1 sm:text-3xl md:text-4xl lg:text-4xl lg:py-2 text-center'>
                {CompanyTagLine}
              </h2>
            </div>

            <div className='grid pt-6'>
              <h3 className='tracking-wider text-center text-colour8 font-bold text-xl underline underline-offset-4'>
                Join Me online or in person
              </h3>

              <div className='grid pt-6'>
                <div className='grid w-full'>
                  <img
                    src={MainImage}
                    alt={`${CompanyName} dominatrix session preview`}
                    className='mx-auto sm:max-w-[60vw] md:max-h-[60vh] rounded neon_shadow'
                    loading='lazy'
                  />
                </div>
              </div>

              <p className='text-center text-lg pt-6 max-w-3xl mx-auto'>
                I offer a variety of seductive, intense, and unforgettable
                sessions — both online and in person. Whether you crave control,
                worship, or deep exploration of your kinkiest desires, I tailor
                each experience to leave you aching for more. Come prepared to
                surrender.
              </p>
            </div>
          </header>

          {/* Main page content */}
          <SessionsPageMainContainer />
        </div>

        {/* FAQ JSON-LD */}
        <FAQSchema items={sessionsPageFaqItems} />
      </div>
    </>
  );
}

export default SessionsPage;
